import { useEffect, useState } from 'react';
import { ExternalLink, Star, CheckCircle } from 'lucide-react';

import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

// Direct Google Review form URL using Place ID
// This opens the review form directly - user just needs to be logged into Google
const GOOGLE_REVIEW_URL = 'https://search.google.com/local/writereview?placeid=ChIJiayfHEagwogRHMrhYV4DNgc';

const ReviewRedirect = () => {
  const [countdown, setCountdown] = useState(5);
  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Redirect to Google Review
          window.location.href = GOOGLE_REVIEW_URL;
          setRedirected(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleReviewClick = () => {
    window.location.href = GOOGLE_REVIEW_URL;
    setRedirected(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          {/* Logo or Brand */}
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900">Owaza Martial Arts</h1>
            <p className="text-gray-600 mt-1">Spring Hill, FL</p>
          </div>

          {/* Thank You Message */}
          <div className="mb-8">
            <div className="w-16 h-16 bg-green-100 dark:bg-green-900/50 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-8 h-8 text-green-600 dark:text-green-400" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
              Thank You for Training With Us!
            </h2>
            <p className="text-gray-600 dark:text-gray-400">
              We'd love to hear about your experience. Your review helps other
              families discover our martial arts programs.
            </p>
          </div>

          {/* Star Rating Display */}
          <div className="flex justify-center gap-1 mb-6">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star key={star} className="w-8 h-8 fill-yellow-400 text-yellow-400" />
            ))}
          </div>

          {/* Redirect Notice */}
          {!redirected ? (
            <div className="mb-6">
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
                Redirecting to Google Reviews in <span className="font-bold text-red-600">{countdown}</span> seconds...
              </p>
              <Button
                onClick={handleReviewClick}
                className="w-full bg-red-600 hover:bg-red-700"
              >
                <ExternalLink className="w-4 h-4 mr-2" />
                Leave a Review Now
              </Button>
            </div>
          ) : (
            <div className="mb-6">
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
                Opening Google Reviews...
              </p>
              <Button
                onClick={handleReviewClick}
                variant="outline"
                className="w-full"
              >
                Click here if the page didn't open
              </Button>
            </div>
          )}

          {/* Contact Info */}
          <div className="pt-4 border-t border-gray-200 dark:border-gray-700 text-sm text-gray-500 dark:text-gray-400">
            <p>14726 County Line Rd, Spring Hill, FL 34610</p>
            <p>(352) 428-0086</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ReviewRedirect;
